import { StoreModel, GlobalFilterModel } from 'src/mst/models';

export const getGlobalFilterModel = (store: StoreModel): GlobalFilterModel => {
  return store.globalFilter;
};
